module.exports = __webpack_public_path__ + "media/images/emblems/Oberhofen_am_Thunersee-coat_of_arms-fb3dbce2acb1f866fd124602896a65ed.svg";